import { NgModule } from '@angular/core';

import { NgIdleModule } from '@ng-idle/core';

import { ConfigurationModule } from '@sondermind/configuration';
import { DirectiveModule } from '@sondermind/utilities/directives';
import { PipesModule } from '@sondermind/utilities/pipes';

@NgModule({
  declarations: [],
  imports: [
    DirectiveModule,
    NgIdleModule.forRoot(),
    PipesModule,
    ConfigurationModule
  ],
  exports: [
    DirectiveModule,
    PipesModule
  ]
})
export class CoreModule {}
